<gcp-workspace-error-state
  heading="401 — Unauthorized"
  message="You are not authorized to view this page."
>
  <button mat-raised-button color="primary" (click)="goToHome()">
    Go back to Home
  </button>
</gcp-workspace-error-state>
